"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));
var _hamburgerMenu = _interopRequireDefault(require("./hamburgerMenu.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var HamburgerMenuWrapper = _styledComponents.default.div.withConfig({
  displayName: "HamburgerMenu__HamburgerMenuWrapper",
  componentId: "sc-9642ap-0"
})(["display:flex;"]);
var HamburgerBtn = _styledComponents.default.button.withConfig({
  displayName: "HamburgerMenu__HamburgerBtn",
  componentId: "sc-9642ap-1"
})(["background-color:transparent;border:0;padding:0;line-height:0;cursor:pointer;"]);
var Overlay = _styledComponents.default.div.withConfig({
  displayName: "HamburgerMenu__Overlay",
  componentId: "sc-9642ap-2"
})(function (_ref) {
  var theme = _ref.theme,
    backgroundColor = _ref.backgroundColor,
    opacity = _ref.opacity,
    zIndex = _ref.zIndex;
  return "\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      z-index: -1;\n      background-color: ".concat(theme.backgroundColor[backgroundColor], ";\n      opacity: 0;\n      transition: ease-in-out 0.2s;\n      overflow: auto;\n\n      &.open{\n        opacity: ").concat(opacity, ";\n        z-index: ").concat(zIndex, ";\n      }\n    ");
});
var MenuContainer = _styledComponents.default.div.withConfig({
  displayName: "HamburgerMenu__MenuContainer",
  componentId: "sc-9642ap-3"
})(function (_ref2) {
  var theme = _ref2.theme,
    open = _ref2.open,
    zIndex = _ref2.zIndex,
    backgroundColor = _ref2.backgroundColor;
  return "\n    position: fixed;\n    left: -100%;\n    top: 0;\n    bottom: 0;\n    width: calc(100% - ".concat(theme.space.semiLarge, ");\n    background-color: ").concat(theme.backgroundColor[backgroundColor], ";\n    z-index: ").concat(zIndex, ";\n    transition: ease-in-out 0.3s;\n    overflow: auto;\n\n    ").concat(open && "\n        left: 0;\n      ", "\n\n    /* width */\n    ::-webkit-scrollbar {\n        width: 4px;\n    }\n\n    /* Track */\n    ::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n        background: ").concat(theme.colors.greyMedium, ";\n        border-radius: ").concat(theme.borderRadius.normal, ";\n    }\n    ");
});
var MenuSection = _styledComponents.default.ul.withConfig({
  displayName: "HamburgerMenu__MenuSection",
  componentId: "sc-9642ap-4"
})(function (_ref3) {
  var theme = _ref3.theme;
  return "\n    margin: 0;\n    padding: 0 0 ".concat(theme.space.XSmall, ";\n    border-bottom: 1px solid ").concat(theme.colors.greyLight, ";\n    ");
});
var MenuItem = _styledComponents.default.li.withConfig({
  displayName: "HamburgerMenu__MenuItem",
  componentId: "sc-9642ap-5"
})(function (_ref4) {
  var theme = _ref4.theme,
    active = _ref4.active,
    textSize = _ref4.textSize,
    activeBackgroundColor = _ref4.activeBackgroundColor,
    titleSize = _ref4.titleSize;
  return "\n    display: flex;\n    padding: ".concat(theme.space.small, " ").concat(theme.space.standard, ";\n    cursor: pointer;\n    align-items: center;\n\n    & [data-class=\"icon-left\"]{\n        margin-right: ").concat(theme.space.small, "\n    }\n\n    & [data-class=\"icon-right\"]{\n        margin-left: auto;\n    }\n\n    & p {\n      font-size: ").concat(theme.fontSize[textSize], "\n    }\n\n    & p.hamburger-section-title{\n      font-size: ").concat(theme.fontSize[titleSize], "\n    }\n\n    ").concat(active && "\n        background-color: ".concat(theme.backgroundColor[activeBackgroundColor], ";\n      "), "\n  ");
});
var MenuCloseBtn = _styledComponents.default.div.withConfig({
  displayName: "HamburgerMenu__MenuCloseBtn",
  componentId: "sc-9642ap-6"
})(function (_ref5) {
  var theme = _ref5.theme,
    zIndex = _ref5.zIndex,
    open = _ref5.open;
  return "\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width:  ".concat(theme.space.semiLarge, ";\n    display: none;\n    align-items: center;\n    justify-content: center;\n    z-index: -1;\n    cursor: pointer;\n\n    ").concat(open && "\n        display: flex;\n        z-index: ".concat(zIndex, ";\n      "), "\n  ");
});
var HamburgerMenu = function HamburgerMenu(props) {
  var data = props.data,
    dataConfig = props.dataConfig,
    menuIconConfig = props.menuIconConfig,
    leftIconConfig = props.leftIconConfig,
    textConfig = props.textConfig,
    rightIconConfig = props.rightIconConfig,
    zIndex = props.zIndex,
    closeButtonConfig = props.closeButtonConfig,
    onClose = props.onClose,
    accessible = props.accessible,
    theme = props.theme,
    customProperties = props.customProperties,
    fireGtm = props.fireGtm,
    idConfig = props.idConfig;
  var _ref6 = idConfig || {},
    parentName = _ref6.parentName,
    widgetName = _ref6.widgetName,
    index = _ref6.index;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    openMenu = _useState2[0],
    setOpenMenu = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    activeItem = _useState4[0],
    setActiveItem = _useState4[1];
  var overlayRef = (0, _react.useRef)(null);
  var _useState5 = (0, _react.useState)('hamburgerMenu'),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    dynamicID = _useState6[0],
    setId = _useState6[1];
  (0, _react.useEffect)(function () {
    var url = 'hamburgerMenu';
    if (parentName) {
      url = "".concat(parentName, "-hamburgerMenu");
    }
    if (index) {
      url += "-".concat(index);
    }
    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }
    setId(url);
  }, [widgetName, parentName, index]);
  var onClickHandler = function onClickHandler(menu) {
    setActiveItem(menu.value);
    if (menu.redirectUrl) {
      if (fireGtm) {
        fireGtm(menu.value, 'true');
      }
      if (menu.newTab === 'TRUE' || menu.newTab === '') {
        window.open(menu.redirectUrl, '_blank');
      } else {
        window.open(menu.redirectUrl, '_self');
      }
    } else if (menu.onClick) {
      menu.onClick(menu.value);
    }
  };
  var removeOverflow = function removeOverflow() {
    if (typeof document !== 'undefined') {
      var bodyElement = document.getElementsByTagName('body');
      if (bodyElement) {
        bodyElement[0].style.removeProperty('overflow');
      }
    }
  };
  (0, _react.useEffect)(function () {
    return function () {
      return removeOverflow();
    };
  }, []);
  var openMenuHandler = function openMenuHandler() {
    setOpenMenu(true);
    if (typeof document !== 'undefined') {
      var bodyElement = document.getElementsByTagName('body');
      if (bodyElement) {
        bodyElement[0].style.overflow = 'hidden';
      }
    }
  };
  var closeHandler = function closeHandler() {
    setOpenMenu(false);
    setActiveItem(null);
    removeOverflow();
    if (onClose) {
      onClose();
    }
  };
  (0, _react.useEffect)(function () {
    if (openMenu) {
      overlayRef.current.classList.add('open');
    }
  }, [openMenu]);
  var getMain = function getMain() {
    var aggregatedMenuConfig = _objectSpread(_objectSpread({}, _hamburgerMenu.default.DefaultProps.menuIconConfig), menuIconConfig);
    var aggregatedLeftIconConfig = _objectSpread(_objectSpread({}, _hamburgerMenu.default.DefaultProps.leftIconConfig), leftIconConfig);
    var aggregatedTextConfig = _objectSpread(_objectSpread({}, _hamburgerMenu.default.DefaultProps.textConfig), textConfig);
    return /*#__PURE__*/_react.default.createElement(HamburgerMenuWrapper, customProperties, /*#__PURE__*/_react.default.createElement(HamburgerBtn, {
      id: "".concat(dynamicID, "-open"),
      "aria-label": "Menu button",
      tabIndex: tabIndex,
      onClick: openMenuHandler
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      color: aggregatedMenuConfig.color,
      fontsize: aggregatedMenuConfig.size,
      icon: aggregatedMenuConfig.icon,
      theme: theme
    })), openMenu && /*#__PURE__*/_react.default.createElement(Overlay, {
      ref: overlayRef,
      onClick: closeHandler,
      backgroundColor: "black",
      opacity: "0.8",
      zIndex: zIndex - 1,
      id: "airasia-phoenix-modal-overlay"
    }), /*#__PURE__*/_react.default.createElement(MenuContainer, {
      open: openMenu,
      zIndex: zIndex,
      backgroundColor: dataConfig.backgroundColor
    },
    // eslint-disable-next-line react/prop-types
    data.map(function (d, idx) {
      return /*#__PURE__*/_react.default.createElement(MenuSection, {
        key: "hamburger-section-item-".concat(idx)
      }, d.title && /*#__PURE__*/_react.default.createElement(MenuItem, {
        titleSize: dataConfig.titleSize
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        color: dataConfig.titleColor,
        theme: theme,
        customProperties: {
          className: 'hamburger-section-title'
        },
        accessible: accessible
      }, d.title)), d.data.map(function (menu, keyIndex) {
        return /*#__PURE__*/_react.default.createElement(MenuItem, {
          key: "hamburger-section-item-content-".concat(keyIndex),
          id: "".concat(dynamicID, "-").concat(idx, "-").concat(keyIndex),
          tabIndex: tabIndex,
          textSize: aggregatedTextConfig.size,
          onClick: function onClick() {
            return onClickHandler(menu);
          },
          activeBackgroundColor: dataConfig.activeBackgroundColor,
          active: activeItem === menu.value
        }, menu.iconLeft && /*#__PURE__*/_react.default.createElement(_Icon.default, {
          color: aggregatedLeftIconConfig.color,
          fontsize: aggregatedLeftIconConfig.size,
          icon: menu.iconLeft,
          theme: theme,
          customProperties: {
            'data-class': 'icon-left'
          },
          accessible: false
        }), /*#__PURE__*/_react.default.createElement(_Text.default, {
          color: aggregatedTextConfig.color,
          accessible: false,
          theme: theme
        }, menu.label), menu.iconRight && /*#__PURE__*/_react.default.createElement(_Icon.default, {
          accessible: false,
          color: rightIconConfig.color,
          fontsize: rightIconConfig.size,
          icon: menu.iconRight,
          theme: theme,
          customProperties: {
            'data-class': 'icon-right'
          }
        }));
      }));
    }), /*#__PURE__*/_react.default.createElement(MenuCloseBtn, {
      id: "".concat(dynamicID, "-close"),
      open: openMenu,
      onClick: closeHandler,
      zIndex: zIndex
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      color: closeButtonConfig.color,
      fontsize: closeButtonConfig.size,
      icon: closeButtonConfig.icon,
      theme: theme
    }))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
HamburgerMenu.propTypes = _hamburgerMenu.default.PropTypes;
HamburgerMenu.defaultProps = _hamburgerMenu.default.DefaultProps;
var _default = HamburgerMenu;
exports.default = _default;